import {
	Button,
	HStack,
	Text,
	VStack,
} from '@montel/montelpro-shared-components-v2';
import { DEVELOPER_API_SYNC_ADMIN_ACCOUNTS } from 'apiRoutes';
import useSubmit, { POST } from 'hooks/useSubmit';
import { useState } from 'react';
import styled from 'styled-components';
import { RequestStatus } from 'types/RequestStatus';

const SyncAdminAccountsTool = () => {
	const [newAdmins, setNewAdmins] = useState<string[]>([]);
	const [updatedAdmins, setUpdatedAdmins] = useState<string[]>([]);
	const [deletedAdmins, setDeletedAdmins] = useState<string[]>([]);

	const [postSyncAdminAccounts, syncAdminAccountsStatus] = useSubmit(
		DEVELOPER_API_SYNC_ADMIN_ACCOUNTS,
		POST,
	);

	const onSubmit = async () => {
		const response = await postSyncAdminAccounts({});
		if (response.success) {
			const { newAdmins, updatedAdmins, deletedAdmins } = response.data;
			setNewAdmins(newAdmins);
			setUpdatedAdmins(updatedAdmins);
			setDeletedAdmins(deletedAdmins);
		}
	};

	const isLoading = syncAdminAccountsStatus === RequestStatus.LOADING;

	return (
		<>
			<Text variant="h1">Sync Admin Accounts Tool</Text>
			<Text>
				This tool will sync admin accounts to the database from Fusion
				Auth.
			</Text>
			<Button
				variant="primary"
				text="Sync"
				onClick={onSubmit}
				isLoading={isLoading}
			/>
			{syncAdminAccountsStatus === RequestStatus.SUCCESS && (
				<>
					<Text>
						{newAdmins.length +
							updatedAdmins.length +
							deletedAdmins.length}{' '}
						total admin accounts required syncing.
					</Text>
					<HStack fullWidth wrap="nowrap">
						<StyledVStack fullWidth>
							<Text>New admin accounts</Text>
							<ul>
								{newAdmins.map((admin) => (
									<li key={admin}>{admin}</li>
								))}
							</ul>
						</StyledVStack>
						<StyledVStack fullWidth>
							<Text>Updated admin accounts</Text>
							<ul>
								{updatedAdmins.map((admin) => (
									<li key={admin}>{admin}</li>
								))}
							</ul>
						</StyledVStack>
						<StyledVStack fullWidth>
							<Text>Deleted admin accounts</Text>
							<ul>
								{deletedAdmins.map((admin) => (
									<li key={admin}>{admin}</li>
								))}
							</ul>
						</StyledVStack>
					</HStack>
				</>
			)}
		</>
	);
};

const StyledVStack = styled(VStack)`
	ul {
		list-style: none;
		padding: 0;
	}
`;

export default SyncAdminAccountsTool;
